import { Crosshair, ZoomIn, ZoomOut } from 'lucide-react';
import React from 'react';

interface ZoomControlsProps {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onCenter: () => void;
  disabled?: boolean;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  scale,
  onZoomIn,
  onZoomOut,
  onCenter,
  disabled = false
}) => {
  const percentage = Math.round(scale * 100);

  return (
    <>
      <button
        onClick={() => onZoomOut()}
        className="rounded-l-lg p-2 transition-colors hover:bg-gray-100"
        title="Zoom Out"
        disabled={disabled || scale <= 0.1}
      >
        <ZoomOut
          size={20}
          className={
            disabled || scale <= 0.1 ? 'text-gray-400' : 'text-gray-700'
          }
        />
      </button>
      <div className="min-w-[60px] px-2 text-center font-medium text-gray-700">
        {percentage}%
      </div>
      <button
        onClick={() => onZoomIn()}
        className="rounded-r-lg p-2 transition-colors hover:bg-gray-100"
        title="Zoom In"
        disabled={disabled || scale >= 5}
      >
        <ZoomIn
          size={20}
          className={disabled || scale >= 5 ? 'text-gray-400' : 'text-gray-700'}
        />
      </button>
      <button
        onClick={onCenter}
        className="rounded-r-lg p-2 transition-colors hover:bg-gray-100"
        title="Center Stage"
        disabled={disabled}
      >
        <Crosshair
          size={20}
          className={disabled ? 'text-gray-400' : 'text-gray-700'}
        />
      </button>
    </>
  );
};
